var exports = {
  "kL": "xf61da738--352898--container",
  "qV": "xf61da738--352898--skeleton",
  "Sl": "xf61da738--352898--image",
  "uX": "xf61da738--352898--primary-line",
  "iM": "xf61da738--352898--shimmer",
};

module.exports = exports;
